document.addEventListener("DOMContentLoaded", () => {
	const enBlock = document.querySelector(
		".privacy-policy__header:not(.hidden)"
	);
	const ruBlock = document.querySelector(".privacy-policy__header.hidden");

	const buttons = document.querySelectorAll(
		".privacy-policy__wrap button[data-tab]"
	);

	buttons.forEach((button) => {
		button.addEventListener("click", () => {
			const tab = button.getAttribute("data-tab");

			if (tab === "en") {
				enBlock.classList.remove("hidden");
				ruBlock.classList.add("hidden");
			} else if (tab === "ru") {
				ruBlock.classList.remove("hidden");
				enBlock.classList.add("hidden");
			}

			buttons.forEach((btn) => btn.classList.remove("is-active"));
			button.classList.add("is-active");

			history.replaceState(null, "", `#${tab}`);
		});
	});
});
